module.exports = __webpack_public_path__ + "img/组 16.dd8fdeab.png";